import { makeStyles } from '@material-ui/core';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const useStyles = makeStyles(
  theme => ({
    root: {
      position: 'relative',
      flexGrow: 1
    },
    title: {
      marginBottom: theme.spacing(2)
    },
    loader: {
      margin: 'auto'
    },
    circularProgressContainer: {
      width: '100%',
      height: '100%',
      ...flexAlignCenterJustifyCenter
    }
  }),
  { classNamePrefix: 'spActivityLogs' }
);
